namespace RioERP.Invoices {
    export interface InvoicePaymentRow {
        Id?: number;
        InvoiceId?: number;
        EPaymentMode?: Web.Enums.PaymentMode;
        Amount?: number;
        EStatus?: RioErp.Web.Enums.InvoiceStatus;
        Note?: string;
        IsActive?: boolean;
        ChequeNumber?: string;
        BankName?: string;
        TransactionId?: string;
        PaymentDate?: string;
        InvoiceInvoicenumber?: string;
        InvoiceInvoiceDate?: string;
        InvoiceInvoiceCompanyId?: number;
        InvoiceEInvoiceType?: number;
        InvoiceEInvoiceTo?: number;
        InvoiceCustomerId?: number;
        InvoiceFranchiseeId?: number;
        InvoiceDiscountAmount?: number;
        InvoiceGrossAmount?: number;
        InvoiceNetAmount?: number;
        InvoiceTaxableAmount?: number;
        InvoiceIsRecalculated?: boolean;
        InvoiceEInvoiceStatus?: number;
        InvoiceBillingAddress1?: string;
        InvoiceBillingAddress2?: string;
        InvoiceBillingCity?: string;
        InvoiceBillingStateId?: number;
        InvoiceBillingPincode?: number;
        InvoiceIsActive?: boolean;
        InvoiceInsertUserId?: number;
        InvoiceInsertDate?: string;
        InvoiceUpdateUserId?: number;
        InvoiceUpdateDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace InvoicePaymentRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Note';
        export const localTextPrefix = 'Invoices.InvoicePayment';
        export const deletePermission = 'Invoices:InvoicesManagement:Modify';
        export const insertPermission = 'Invoices:InvoicesManagement:Modify';
        export const readPermission = 'Invoices:InvoicesManagement:View';
        export const updatePermission = 'Invoices:InvoicesManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            InvoiceId = "InvoiceId",
            EPaymentMode = "EPaymentMode",
            Amount = "Amount",
            EStatus = "EStatus",
            Note = "Note",
            IsActive = "IsActive",
            ChequeNumber = "ChequeNumber",
            BankName = "BankName",
            TransactionId = "TransactionId",
            PaymentDate = "PaymentDate",
            InvoiceInvoicenumber = "InvoiceInvoicenumber",
            InvoiceInvoiceDate = "InvoiceInvoiceDate",
            InvoiceInvoiceCompanyId = "InvoiceInvoiceCompanyId",
            InvoiceEInvoiceType = "InvoiceEInvoiceType",
            InvoiceEInvoiceTo = "InvoiceEInvoiceTo",
            InvoiceCustomerId = "InvoiceCustomerId",
            InvoiceFranchiseeId = "InvoiceFranchiseeId",
            InvoiceDiscountAmount = "InvoiceDiscountAmount",
            InvoiceGrossAmount = "InvoiceGrossAmount",
            InvoiceNetAmount = "InvoiceNetAmount",
            InvoiceTaxableAmount = "InvoiceTaxableAmount",
            InvoiceIsRecalculated = "InvoiceIsRecalculated",
            InvoiceEInvoiceStatus = "InvoiceEInvoiceStatus",
            InvoiceBillingAddress1 = "InvoiceBillingAddress1",
            InvoiceBillingAddress2 = "InvoiceBillingAddress2",
            InvoiceBillingCity = "InvoiceBillingCity",
            InvoiceBillingStateId = "InvoiceBillingStateId",
            InvoiceBillingPincode = "InvoiceBillingPincode",
            InvoiceIsActive = "InvoiceIsActive",
            InvoiceInsertUserId = "InvoiceInsertUserId",
            InvoiceInsertDate = "InvoiceInsertDate",
            InvoiceUpdateUserId = "InvoiceUpdateUserId",
            InvoiceUpdateDate = "InvoiceUpdateDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
